import { styled } from '@mui/material/styles';

import AtomFlex from '../../../atoms/AtomFlex';
import { styleConfigs } from '../../../resources/styleConfigs';
import BoxWrapper from '../../../wrappers/BoxWrapper';

export const BoxStyled = styled(BoxWrapper)({
  paddingBottom: styleConfigs.marginPadding.custom50,
});

export const AtomFlexStyled = styled(AtomFlex)({
  height: styleConfigs.dimensions.percent100,
});
